import { Component, OnInit, Inject } from '@angular/core';
import {SESSION_STORAGE, WebStorageService} from 'ngx-webstorage-service';

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.css']
})
export class AppLayoutComponent implements OnInit {

  nombreUsuario="";

  constructor(
    @Inject(SESSION_STORAGE) private storage: WebStorageService,
  ) { }

  ngOnInit(): void {
    this.nombreUsuario=this.storage.get("nombreUsuario");
  }

  cerrarSesion(){

  }
}
